var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 6165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1046",
    d: "M13.2969 9.125L4.625 17.7969",
    stroke: "#FF9027",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 6164"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 522",
    cx: 11.8906,
    cy: 16.2344,
    r: 1.79688,
    stroke: "#FF9027",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 523",
    cx: 6.10938,
    cy: 10.4531,
    r: 1.79688,
    stroke: "#FF9027",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3285",
    d: "M1.34375 3C1.34375 1.89543 2.23918 1 3.34375 1H10.875L16.6562 6.78125V19C16.6562 20.1046 15.7608 21 14.6563 21H3.34375C2.23918 21 1.34375 20.1046 1.34375 19V3Z",
    stroke: "#FF9027",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1047",
    d: "M10.875 4.78125V1L16.6562 6.78125H12.875C11.7704 6.78125 10.875 5.88582 10.875 4.78125Z",
    stroke: "#FF9027",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageIcon);
export default __webpack_public_path__ + "static/media/PercentageIcon.a017c3a1d189587a42981fd1af638c08.svg";
export { ForwardRef as ReactComponent };